import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RatingScaleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RatingScale",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "4.66",
      cy: "16",
      r: "3.52"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.66 20.66C2.09 20.66 0 18.57 0 16s2.09-4.66 4.66-4.66S9.32 13.43 9.32 16s-2.09 4.66-4.66 4.66m0-7.03c-1.31 0-2.37 1.07-2.37 2.37s1.06 2.38 2.37 2.38S7.03 17.31 7.03 16s-1.06-2.37-2.37-2.37"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "16",
      cy: "16",
      r: "3.52"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 20.66c-2.57 0-4.66-2.09-4.66-4.66s2.09-4.66 4.66-4.66 4.66 2.09 4.66 4.66-2.09 4.66-4.66 4.66m0-7.03c-1.31 0-2.37 1.07-2.37 2.37s1.06 2.38 2.37 2.38 2.37-1.07 2.37-2.38-1.06-2.37-2.37-2.37M27.34 20.66c-2.57 0-4.66-2.09-4.66-4.66s2.09-4.66 4.66-4.66S32 13.43 32 16s-2.09 4.66-4.66 4.66m0-7.03c-1.31 0-2.37 1.07-2.37 2.37s1.06 2.38 2.37 2.38 2.37-1.07 2.37-2.38-1.06-2.37-2.37-2.37"
    })]
  }));
};
RatingScaleIcon.displayName = 'RatingScaleIcon';